// Contactos oficiales de atención al cliente para proveedores de luz prepago
// y otros servicios donde el recibo necesita mostrar un teléfono de soporte
// del proveedor (no de RecargameYa).
//
// Actualizado 24-Oct-2026. Fuentes:
//   - Edesur:   https://www.edesur.com.do (línea gratuita)
//   - Edenorte: https://www.edenorte.com.do (contact-center)
//   - Edeeste:  https://www.edeeste.com.do (centro de atención)
//   - CEB:      https://www.ceb.com.do (atención al cliente Boca Chica)
//   - CEPM:     https://www.cepm.com.do (atención al cliente Punta Cana / Bávaro)
//
// Si alguno cambia, basta con editarlo aquí y queda reflejado en recibo
// pantalla + recibo impresora en el acto.

export const PROVIDER_CONTACTS = {
  edesur_prepago:   { name: 'EDESUR',   phone: '809-683-9292', hours: '24/7' },
  edesur_pre:       { name: 'EDESUR',   phone: '809-683-9292', hours: '24/7' },
  edesur:           { name: 'EDESUR',   phone: '809-683-9292', hours: '24/7' },
  edenorte_prepago: { name: 'EDENORTE', phone: '809-671-3000', hours: '24/7' },
  edenorte_pre:     { name: 'EDENORTE', phone: '809-671-3000', hours: '24/7' },
  edenorte:         { name: 'EDENORTE', phone: '809-671-3000', hours: '24/7' },
  edeeste_prepago:  { name: 'EDEESTE',  phone: '809-539-5000', hours: '24/7' },
  edeeste_pre:      { name: 'EDEESTE',  phone: '809-539-5000', hours: '24/7' },
  edeeste:          { name: 'EDEESTE',  phone: '809-539-5000', hours: '24/7' },
  ceb_prepago:      { name: 'CEB',      phone: '809-523-5111', hours: 'Lun–Vie 8am–5pm' },
  ceb_pre:          { name: 'CEB',      phone: '809-523-5111', hours: 'Lun–Vie 8am–5pm' },
  ceb:              { name: 'CEB',      phone: '809-523-5111', hours: 'Lun–Vie 8am–5pm' },
  cepm_prepago:     { name: 'CEPM',     phone: '809-959-5555', hours: '24/7' },
  cepm_pre:         { name: 'CEPM',     phone: '809-959-5555', hours: '24/7' },
  cepm:             { name: 'CEPM',     phone: '809-959-5555', hours: '24/7' },
};

// Nombres bonitos para mostrar en el recibo (código técnico → nombre amigable).
// Si no aparece aquí, el fallback es el código en MAYÚSCULAS.
export const PROVIDER_DISPLAY_NAMES = {
  edesur_prepago:   'EDESUR PREPAGO',
  edesur_pre:       'EDESUR PREPAGO',
  edesur:           'EDESUR',
  edenorte_prepago: 'EDENORTE PREPAGO',
  edenorte_pre:     'EDENORTE PREPAGO',
  edenorte:         'EDENORTE',
  edeeste_prepago:  'EDEESTE PREPAGO',
  edeeste_pre:      'EDEESTE PREPAGO',
  edeeste:          'EDEESTE',
  ceb_prepago:      'CEB PREPAGO',
  ceb_pre:          'CEB PREPAGO',
  ceb:              'CEB',
  cepm_prepago:     'CEPM PREPAGO',
  cepm_pre:         'CEPM PREPAGO',
  cepm:             'CEPM',
  claro:            'CLARO',
  altice:           'ALTICE',
  viva:             'VIVA',
  digicel:          'DIGICEL',
  natcom:           'NATCOM',
  claro_data:       'CLARO DATOS',
  altice_data:      'ALTICE DATOS',
  viva_data:        'VIVA DATOS',
  claro_hogar:      'CLARO HOGAR',
  altice_hogar:     'ALTICE HOGAR',
  caasd:            'CAASD',
  coraasan:         'CORAASAN',
};

/**
 * Devuelve un nombre humano para mostrar en el recibo a partir del código
 * técnico del proveedor. Si no se encuentra en el mapa, se formatea
 * reemplazando guiones bajos por espacios y convirtiendo a MAYÚSCULAS.
 */
export function getProviderDisplayName(provider) {
  if (!provider) return '';
  const key = String(provider).trim().toLowerCase().replace(/[\s-]+/g, '_');
  if (PROVIDER_DISPLAY_NAMES[key]) return PROVIDER_DISPLAY_NAMES[key];
  // Fallback: formatear el código crudo ("edesur_pre" → "EDESUR PRE")
  return key.replace(/_/g, ' ').toUpperCase();
}

// Fallback cuando no logramos resolver el provider exactamente.
const FALLBACK_CONTACT = { name: null, phone: '809-683-9292', hours: null };

/**
 * Devuelve el contacto oficial del proveedor de la transacción.
 * Normaliza el `provider` (minúsculas, guiones→underscore) y busca:
 *   1. Match exacto por código normalizado.
 *   2. Match por substring (ej. provider="EDESUR Prepago" → edesur_prepago).
 * Si no encuentra nada, devuelve el fallback.
 */
export function getProviderContact(provider) {
  if (!provider) return FALLBACK_CONTACT;
  const key = String(provider).trim().toLowerCase().replace(/[\s-]+/g, '_');
  if (PROVIDER_CONTACTS[key]) return PROVIDER_CONTACTS[key];
  // Fallback: buscar por substring
  for (const [code, info] of Object.entries(PROVIDER_CONTACTS)) {
    const base = code.replace('_prepago', '');
    if (key.includes(base)) return info;
  }
  return FALLBACK_CONTACT;
}
